type ExcludeFunction<T> = (T extends (...args: any) => any ? never : T);
export const getLastNonNullValue = <T>(arr: ExcludeFunction<T>[], defaultValue?: ExcludeFunction<T>) => {
   return arr.reduce((acc, curr) => curr ? curr : acc) || defaultValue;
}

export function splitArrayChunks<T>(array: T[], n: number): T[][] {
   const result: T[][] = [];

   for (let i = 0; i < array?.length; i += n) {
      result.push(array?.slice(i, i + n));
   }

   return result;
}

export const groupBy = <RetType extends string | number | symbol, T, Func extends (arg: T, index: number, array: T[]) => RetType>(array: T[], predicate: Func) =>
   array.reduce((acc, value, index, array) => {
      (acc[predicate(value, index, array)] ||= []).push(value);
      return acc;
   }, {} as Record<RetType, T[]>);

export const pipe = (...fns) => x => fns.reduce((v, f) => f(v), x);

export function findLastIndex<T>(array: Array<T>, predicate: (value: T, index: number, obj: T[]) => boolean): number {
   let l = array.length;
   while (l--) {
      if (predicate(array[l], l, array))
         return l;
   }
   return -1;
}
